import { useRouter } from 'next/router'
import { RefObject, useEffect } from 'react'

import ReviewTile from '@/molecules/ReviewTile'
import Pagination from '@/organisms/Pagination/Pagination'
import { ProductReview } from '@/ts/Product'

function ReviewsList({ reviews, anchorElement }: ReviewsProps) {
  const { query } = useRouter()
  const page = Number(query?.page || 1)

  useEffect(() => {
    if (query?.page) anchorElement?.current?.scrollIntoView()
  }, [query?.page])

  return (
    <div className="w-full">
      {reviews.slice(10 * (page - 1), 10 * page).map((review) => (
        <ReviewTile key={review.id} review={review} />
      ))}
      <Pagination totalItems={reviews.length} limit={10} replace />
    </div>
  )
}

interface ReviewsProps {
  reviews: ProductReview[]
  anchorElement: RefObject<HTMLElement>
}

export default ReviewsList
